var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-navigation-layout', {
    attrs: {
      "items": _vm.items,
      "title": _vm.title,
      "isEnabled": _vm.isEnabled
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }